import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import UltraMindBanner from '../components/UltraMindBanner';
import ProblemSection from '../components/ProblemSection';
import ArchitectureSection from '../components/ArchitectureSection';
import TokenomicsSection from '../components/TokenomicsSection';
import RoadmapSection from '../components/RoadmapSection';
import EcosystemSection from '../components/EcosystemSection';
import TeamSection from '../components/TeamSection';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';

const Home = () => (
  <div style={{ background: 'var(--sb-bg-1)', minHeight: '100vh' }} data-testid="home-page">
    <Navbar />
    <main style={{ position: 'relative', zIndex: 10 }}>
      <HeroSection />
      <UltraMindBanner />
      <ProblemSection />
      <ArchitectureSection />
      <TokenomicsSection />
      <RoadmapSection />
      <EcosystemSection />
      <TeamSection />
      <CTASection />
      <Footer />
    </main>
  </div>
);

export default Home;
